// Constants for Midship workspace identification
const MIDSHIP_WORKSPACE_ID_PREFIXES: string[] = [
  // prod - midship.dev
  "225963d4-d",
  // demo
  "832582ea-6",
  // dev - midship.dev
  "7a402f7f-4",
];

const PREFIX_LENGTH = 10;

/**
 * Helper to check if Midship-specific features should be enabled.
 * Returns true if either:
 * - The workspace ID matches any of the allowed Midship workspace prefixes
 * - The user email ends with @midship.dev or @midship.ai
 */
export const shouldEnableMidshipFeatures = (
  workspaceId?: string,
  userEmail?: string,
): boolean => {
  // Check workspace ID
  if (workspaceId) {
    const prefix = workspaceId.substring(0, PREFIX_LENGTH);
    if (MIDSHIP_WORKSPACE_ID_PREFIXES.includes(prefix)) {
      return true;
    }
  }

  // Check user email
  if (userEmail) {
    const emailLower = userEmail.toLowerCase();
    if (
      emailLower.endsWith("@midship.dev") ||
      emailLower.endsWith("@midship.ai")
    ) {
      return true;
    }
  }

  return false;
};
